import React from 'react';
import Helmet from 'react-helmet';
import img1 from '../../assets/img/our-partners-img1.svg';
import img3 from '../../assets/img/sg-news-img3.png';
import cx from 'classnames';
import styles from './SGNews.module.scss';

export default function SGNews() {
  return (
    <div className="main-section" style={{ margin: '2% 0 4%'}}>
      <div className="page-section">
        <div className="container">
          <Helmet>
            <title>SG News</title>
          </Helmet>
          <div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="cs-section-title center">
                <h2>Smartguppy News</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-section">
        <div className="container">
          <div className="row">
            <div className="section-fullwidtht col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="row visible-sm visible-xs">
                <div className="col-md-4">
                  <img src={img1} height="380" alt="SG News"/>
                </div>
                <div className={cx('col-md-8', styles.text)}>
                  In the News… Anything SmartGuppy and related to our Cause for Education Equality!  
                </div>    
              </div>
              <div className={cx('visible-lg visible-md', styles.header)}>
                <img src={img1} height="380" alt="SG News"/>
                <div className="col-md-8" style={{ fontFamily: 'Comfortaa' }}>
                  In the News… Anything SmartGuppy and related to our Cause for Education Equality!  
                </div>    
              </div>
            </div>
            <div className="container center">
              <div className="col-lg-10">
                <div className="cs-section-title">
                  <h2>
                    Throwing Money At Singapore’s Problems Won’t Fix Them
                  </h2>
                </div>
                <div className="row">
                  <div className="col-md-8">
                    <div style={{ textAlign: 'left' }}>
                      We were proud to be featured in Rice's latest article regarding social activism and volunteerism among the youths in Singapore.
                      Are we merely just a materialistic society that cares only about making money, 
                      or one that only pays platitudes towards social causes, or is there something much deeper than that in all of us?
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <a 
                        href="https://www.ricemedia.co/current-affairs-commentary-throwing-money-problems/" 
                        style={{ color: 'blue' }}
                      >
                          &hellip;read more
                      </a>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: '30px'}}>
                  <img src={img3} alt="SG News"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
